import { BoddCountry } from '@services';

export interface Country {
    code: BoddCountry; // ISO 3166-1 alpha-2
    name: string; // displayable country name
    topLevelDomain: string; // top level domain country code
}

export default class CountryHelpers {
    static readonly countries: Country[] = [
        { code: 'Au', name: 'Australia', topLevelDomain: 'au' },
        { code: 'Ca', name: 'Canada', topLevelDomain: 'ca' },
        { code: 'Nz', name: 'New Zealand', topLevelDomain: 'nz' },
        { code: 'Th', name: 'Thailand', topLevelDomain: 'th' },
        { code: 'Us', name: 'United States of America', topLevelDomain: 'us' },
        { code: 'Ie', name: 'Ireland', topLevelDomain: 'ie' },
        { code: 'Gb', name: 'United Kingdom', topLevelDomain: 'uk' },
    ];

    static getRegion = (countryCode: string) => CountryHelpers.countries.find((item) => item.code === countryCode)?.topLevelDomain ?? '';
}
